var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoeur3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 425.2 356.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1251b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.53,26.37C71.05,57.08,75.68,107,83,148.55c10.31,58.73,21.19,117.38,31.8,176.06A7.38,7.38,0,0,0,115,326l.24,1.3c1,5.34,5.47,6.86,9.53,5.72a9.09,9.09,0,0,0,2.91-.73c44.46-19.81,91.13-34,136.63-51.11,35.22-13.27,82.15-27.77,102.63-62.05,17.45-29.2,2.57-62.32-25.47-77.79C309.33,123.6,273,133.79,240.7,146.2c-2.23-39.17-7.4-81.5-36.52-110.09C177.94,10.35,136.25.65,106.53,26.37m91.15,27.74c1.63,1.94,3.15,3.92,4.57,6A7.71,7.71,0,0,0,197.62,64c-3.15,5.82-11.44,7-14.36.3S187,52.35,193.41,54.07a8,8,0,0,0,4.27,0m84,96.75q4.17-.87,8.34-1.42c-1.78,2.71-5.56,3-8.34,1.42m9.65,99c-5.77-3.53-.86-10.71,4.28-11.5s8.63,3.45,9,8.15q-5.49,2.73-11.06,5.32a9,9,0,0,0-2.24-2m-184.41-63.8c-.26-1.47-.56-3-.85-4.45a8.73,8.73,0,0,0,2-1.59c6.14-6.55,17-6.46,20.78,2.5a12.17,12.17,0,0,1-12.46,16.84,8.8,8.8,0,0,0-6.76,2l-2.76-15.28m-7-119.8c8.34,2.58,14.76-9.5,7.43-14.89C124.69,25.6,155.59,23,180.6,38.94c-11.51,5.15-18.61,18.63-12.87,32,7.83,18.26,32.08,19.25,42.93,4.07,11.37,25.61,12.42,56.43,13.72,83.49.24,4.95,5.51,10.1,10.78,8,9.11-3.65,18.82-7.58,28.79-10.82a22.81,22.81,0,0,0,20.51,13.24c12.29.07,20.85-8.83,23.05-20.11a61.87,61.87,0,0,1,27.61,8.47c14.05,8.34,24.73,22.91,22,39.84-3.11,19.58-20.75,32.12-37.07,41.29-4.47-12.49-18.21-20.29-31.8-15.48-15.65,5.54-20.77,24.34-11.44,36.25-48,20.13-99.12,33.83-147,53.92q-8.79-48.63-17.57-97.26l.11,0c21.26,2.4,40.49-16.12,32.85-37.91-6.43-18.36-27.69-24.27-43-14.87-6.68-32-13.54-66.77-2.42-96.77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.19,176.34c9.52,5.32,1.27,20.12-8.26,14.79s-1.27-20.11,8.26-14.79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.06,96.36c9.52,5.32,1.27,20.12-8.26,14.79S138.52,91,148.06,96.36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.62,199c-12.1-1.86-22.85,5.89-26,17.59s2.47,24.5,14.07,28.74,26.18-1.14,31.33-12.68a8.64,8.64,0,0,0,.62-5.42,7.18,7.18,0,0,0,1.46-5.55A25.57,25.57,0,0,0,222.62,199m-9.5,21.62c2-7.31,13.25-5.91,14.09,1.39a9.31,9.31,0,0,0,.39,1.82c-.1.19-.23.35-.32.56-3.77,8.43-17,6.42-14.16-3.77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.24,234.28c9.52,5.32,1.27,20.12-8.26,14.79s-1.27-20.11,8.26-14.79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.44,163.25c9.52,5.31,1.28,20.11-8.26,14.79s-1.27-20.12,8.26-14.79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.34,177c9.52,5.31,1.27,20.11-8.26,14.79s-1.28-20.11,8.26-14.79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266,181c9.52,5.32,1.28,20.12-8.25,14.79S256.51,175.68,266,181"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.29,239.11c9.52,5.32,1.27,20.12-8.26,14.79s-1.27-20.11,8.26-14.79"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195,129.35c9.52,5.31,1.28,20.11-8.26,14.79S185.43,124,195,129.35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.81,202c9.52,5.31,1.28,20.11-8.26,14.79s-1.27-20.12,8.26-14.79"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.58,265.51c9.52,5.31,1.27,20.11-8.26,14.79s-1.28-20.11,8.26-14.79"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.55,263.32c9.52,5.32,1.27,20.12-8.26,14.8S141,258,150.55,263.32"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.07,111.69c9.52,5.32,1.27,20.12-8.26,14.79s-1.27-20.11,8.26-14.79"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.21,41c9.52,5.32,1.28,20.12-8.26,14.8s-1.27-20.12,8.26-14.8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.31,97.34c9.51,5.32,1.27,20.12-8.26,14.79S198.77,92,208.31,97.34"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.66,131.5c9.52,5.32,1.27,20.12-8.26,14.8s-1.27-20.12,8.26-14.8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.05,90.72c-9.52-5.32-1.28-20.12,8.26-14.79s1.27,20.11-8.26,14.79"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.5,159.54c9.52,5.31,1.27,20.11-8.26,14.79s-1.28-20.12,8.26-14.79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoeur3);
export default __webpack_public_path__ + "static/media/coeur3.b85063a8ddb0f6992dc7f25ca17fcfda.svg";
export { ForwardRef as ReactComponent };